<div class="row page-header">
    <div class="col-12">
        <h1>Welcome to VanCon WebApps <small>View Notifications, To-Dos, and more</small></h1>
    </div>
</div>

@if (shouldShowDuckDuckGoAlert()) {
    <div class="alert alert-light border-start border-info border-3 d-flex justify-content-between align-items-start" role="alert">
        <div class="flex-grow-1">
            <h6 class="alert-heading text-muted mb-2">DuckDuckGo Browser Detected</h6>
            <p class="mb-0 text-muted small">
                It appears you are using DuckDuckGo which does not support push Notifications. While you won't receive push notifications on
                this device, you can still view a list of notifications that have been sent to you.
            </p>
        </div>
        <button type="button" class="btn-close btn-close-sm ms-2" aria-label="Dismiss" (click)="dismissDuckDuckGoAlert()"></button>
    </div>
}

@if (!deviceNotificationService.token() && showRequestButton() && !isDuckDuckGo()) {
    <button class="btn btn-warning" (click)="requestNotifications()">Request Notifications</button>
}
@if (!deviceNotificationService.token() && showRequestButton() && deviceNotificationService.showInstructions() && !isDuckDuckGo()) {
    <div>
        @if (!deviceNotificationService.isIOS()) {
            <h5>Instructions to enable notifications</h5>
            <p>
                To receive notifications, please follow these steps: (Note: if these steps do not appear to match your device, use this
                <a href="https://vanconinc-hff.viewpointforcloud.com/home/bulletin/634" target="_blank">Additional Instructions link.)</a>
            </p>
            <ol>
                <li>Tap the settings shown below to allow notifications. The exact appearance may vary by device.</li>
                <img class="step-image" src="assets/permissions.png" alt="Notification Instructions" class="img-fluid" />
                <li>Click the "Request Notifications" button above again.</li>
            </ol>
        }
        @if (deviceNotificationService.isIOS()) {
            <h5>Instructions to enable notifications</h5>
            <p>To receive notifications, please follow these steps:</p>
            <ol>
                <li>Ensure your iOS device is updated to version 16.2 or later</li>
                <li>In Safari, navigate to https://webapps.wedigutah.com/ and click on the icon shown below:</li>
                <img class="step-image" src="assets/step1.png" alt="Step1" class="img-fluid" />
                <li>From the menu that opens, choose the 'Add to Home Screen' option.</li>
                <img class="step-image" src="assets/step2.png" alt="Step2" class="img-fluid" />
                <li>
                    From here on out, you will not open the website in Safari, but from the home screen, as if it were an installed app.
                    Find the icon and open it.
                </li>
                <img class="step-image" src="assets/step3.png" alt="Step2" class="img-fluid" />
                <li>
                    Sign into the 'app' using your credentials, and you should find yourself on the Home screen, and see a button named
                    'Request Notifications'. Tap on it.
                </li>
                <li>When prompted, choose to allow the notifications.</li>
                <img class="step-image" src="assets/step5.png" alt="Step2" class="img-fluid" />
            </ol>
        }
    </div>
}

<div>
    <div class="row">
        <div class="col-lg-5">
            <app-home-notifications style="margin-bottom: 100px" [instanceId]="notificationId"></app-home-notifications>
        </div>
        <div class="col-lg-7">
            <app-user-to-dos></app-user-to-dos>
        </div>
    </div>
    <div class="row" style="margin-top: 20px">
        <div class="col-lg-5">
            <app-user-rocks></app-user-rocks>
        </div>
        <div class="col-lg-7">
            <app-user-metrics></app-user-metrics>
        </div>
    </div>
</div>
